<template>
  <el-dialog title="修改设备" :visible="visible" @update:visible="$emit('update:visible', $event)" width="880px" :close-on-click-modal="false" @close="onClose">
    <div v-loading="loading">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="equipment-form">
        <!-- 基础信息（两列） -->
        <el-divider content-position="left">基础信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="设备名称" prop="name">
              <el-input v-model="form.name" placeholder="请输入设备名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规格型号" prop="model">
              <el-input v-model="form.model" placeholder="请输入规格型号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出厂编号" prop="factory_no">
              <el-input v-model="form.factory_no" placeholder="请输入出厂编号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="使用科室" prop="department">
              <department-select v-model="form.department" placeholder="请输入使用科室" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产厂家" prop="manufacturer">
              <el-input v-model="form.manufacturer" placeholder="请输入生产厂家" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="安装日期">
              <el-date-picker v-model="form.install_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产日期">
              <el-date-picker v-model="form.production_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="使用期限">
              <el-input v-model="form.service_life" placeholder="请输入使用期限">
                <template slot="suffix">年</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备价格">
              <el-input v-model="form.price" placeholder="价格（元）" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到期日期">
              <el-date-picker v-model="form.warranty_expiry_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="使用状态">
              <el-select v-model="form.status" placeholder="请选择" style="width: 100%">
                <el-option label="在用" :value="1" />
                <el-option label="报废" :value="2" />
                <el-option label="维修" :value="3" />
                <el-option label="停用" :value="4" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="固定资产">
              <el-select v-model="form.is_fixed_asset" placeholder="请选择" style="width: 100%">
                <el-option label="是" value="是" />
                <el-option label="否" value="否" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 图片与二维码 -->
        <el-divider content-position="left">图片与二维码</el-divider>
        <el-row :gutter="24" class="upload-row">
          <el-col :span="8">
            <div class="upload-label">设备照片</div>
            <div class="image-box" :class="{ 'has-image': photoPreviewUrl || form.photo_url }">
              <img v-if="photoPreviewUrl" :src="photoPreviewUrl" class="preview-img" alt="设备照片" />
              <img v-else-if="form.photo_url" :src="form.photo_url" class="preview-img" alt="设备照片" />
              <div v-else class="upload-placeholder">
                <i class="el-icon-picture-outline upload-icon"></i>
                <div class="upload-tip">暂无，可上传</div>
              </div>
            </div>
            <div style="text-align: center; margin-top: 8px">
              <el-upload
                action="#"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="handlePhotoChange"
                accept="image/*"
                style="display: inline-block"
              >
                <el-button size="small" type="primary" icon="el-icon-upload">
                  {{ form.photo_url ? '重新上传' : '上传照片' }}
                </el-button>
              </el-upload>
              <el-button
                v-if="photoPreviewUrl || form.photo_url"
                size="small"
                icon="el-icon-zoom-in"
                style="margin-left: 8px"
                @click="handlePhotoPreview"
              >预览</el-button>
            </div>
            <div v-if="photoPreviewUrl" style="text-align: center; margin-top: 4px">
              <el-link type="danger" :underline="false" @click="clearPhoto">撤销替换</el-link>
            </div>
          </el-col>

          <el-col :span="8">
            <div class="upload-label">设备铭牌</div>
            <div class="image-box" :class="{ 'has-image': nameplatePreviewUrl || form.nameplate_url }">
              <img v-if="nameplatePreviewUrl" :src="nameplatePreviewUrl" class="preview-img" alt="设备铭牌" />
              <img v-else-if="form.nameplate_url" :src="form.nameplate_url" class="preview-img" alt="设备铭牌" />
              <div v-else class="upload-placeholder">
                <i class="el-icon-picture-outline upload-icon"></i>
                <div class="upload-tip">暂无，可上传</div>
              </div>
            </div>
            <div style="text-align: center; margin-top: 8px">
              <el-upload
                action="#"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="handleNameplateChange"
                accept="image/*"
                style="display: inline-block"
              >
                <el-button size="small" type="primary" icon="el-icon-upload">
                  {{ form.nameplate_url ? '重新上传' : '上传铭牌' }}
                </el-button>
              </el-upload>
              <el-button
                v-if="nameplatePreviewUrl || form.nameplate_url"
                size="small"
                icon="el-icon-zoom-in"
                style="margin-left: 8px"
                @click="handleNameplatePreview"
              >预览</el-button>
            </div>
            <div v-if="nameplatePreviewUrl" style="text-align: center; margin-top: 4px">
              <el-link type="danger" :underline="false" @click="clearNameplate">撤销替换</el-link>
            </div>
          </el-col>

          <el-col :span="8">
            <div class="upload-label">二维码（不可修改）</div>
            <div class="image-box has-image">
              <img v-if="form.qrcode_url" :src="form.qrcode_url" class="preview-img" alt="二维码" />
              <div v-else class="upload-placeholder">
                <i class="el-icon-picture-outline upload-icon"></i>
                <div class="upload-tip">暂无</div>
              </div>
            </div>
            <div class="qr-tip">二维码由系统生成，不可修改</div>
          </el-col>
        </el-row>

        <!-- 资质信息 -->
        <el-divider content-position="left">资质信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="合格证" label-width="90px">
              <el-select v-model="form.has_certificate" placeholder="请选择" style="width: 100%">
                <el-option label="有" value="有" />
                <el-option label="无" value="无" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册证" label-width="90px">
              <el-select v-model="form.has_registration" placeholder="请选择" style="width: 100%">
                <el-option label="有" value="有" />
                <el-option label="无" value="无" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产许可证" label-width="90px">
              <el-select v-model="form.has_production_license" placeholder="请选择" style="width: 100%">
                <el-option label="有" value="有" />
                <el-option label="无" value="无" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="营业执照" label-width="90px">
              <el-select v-model="form.has_business_license" placeholder="请选择" style="width: 100%">
                <el-option label="有" value="有" />
                <el-option label="无" value="无" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期至" label-width="90px">
              <el-date-picker v-model="form.expire_date" type="date" value-format="yyyy-MM-dd" placeholder="选择有效期" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="资质文件" label-width="90px">
              <div v-if="form.qualification_url" style="margin-bottom: 6px">
                <el-link type="primary" :href="form.qualification_url" target="_blank" icon="el-icon-document">
                  查看当前 PDF
                </el-link>
              </div>
              <el-upload
                action="#"
                :auto-upload="false"
                :on-change="handleQualFileChange"
                :on-remove="handleQualFileRemove"
                :file-list="qualFileList"
                accept=".pdf"
              >
                <el-button type="primary" icon="el-icon-upload">
                  {{ form.qualification_url ? '重新上传 PDF' : '上传 PDF' }}
                </el-button>
                <div slot="tip" class="el-upload__tip">仅支持 PDF，不选择则保留原文件</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注信息">
              <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <span slot="footer">
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">保存</el-button>
    </span>

    <!-- 图片放大预览：自绘悬浮窗（可拖到屏幕任意处、点击窗外穿透可直接填表；滚轮缩放 + 拖拽平移） -->
    <div
      v-if="previewVisible"
      class="preview-float"
      :style="{ left: panelX + 'px', top: panelY + 'px', width: panelW + 'px' }"
    >
      <div class="preview-float-header" @mousedown.prevent="onPanelDragStart">
        <span class="preview-float-title">{{ previewTitle }}</span>
        <i class="el-icon-close preview-float-close" title="关闭" @click="closePreview"></i>
      </div>
      <div class="preview-float-body" @wheel.prevent="onPreviewWheel">
        <img
          v-if="previewUrl"
          :src="previewUrl"
          :style="previewImgStyle"
          alt="预览"
          @mousedown.prevent="onPreviewMouseDown"
          @mousemove="onPreviewMouseMove"
          @mouseup="onPreviewMouseUp"
          @mouseleave="onPreviewMouseUp"
          @dblclick="resetPreviewTransform"
        />
      </div>
      <div class="preview-float-tip">拖动标题栏移动窗体 · 滚轮缩放 · 按住图片平移 · 双击复位 · Esc 关闭</div>
    </div>
  </el-dialog>
</template>

<script>
import equipmentApi from '../api/equipment'

import DepartmentSelect from './DepartmentSelect.vue'

export default {
  name: 'EquipmentEditDialog',
  components: { DepartmentSelect },
  props: {
    visible: Boolean,
    equipmentId: [String, Number],
  },
  data() {
    return {
      form: this.emptyForm(),
      rules: {
        name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        factory_no: [{ required: true, message: '请输入出厂编号', trigger: 'blur' }],
        service_life: [
          { pattern: /^\d+$/, message: '使用期限请输入正整数（单位：年）', trigger: 'blur' },
        ],
        price: [
          { pattern: /^\d+(\.\d{1,2})?$/, message: '价格格式不正确（最多两位小数）', trigger: 'blur' },
        ],
      },
      loading: false,
      submitting: false,

      photoFile: null,
      nameplateFile: null,
      qualFile: null,
      qualFileList: [],
      photoPreviewUrl: '',
      nameplatePreviewUrl: '',
      previewVisible: false,
      previewUrl: '',
      previewTitle: '',
      previewScale: 1,
      previewTx: 0,
      previewTy: 0,
      previewDragging: false,
      panelX: null,
      panelY: null,
      panelW: 0,
    }
  },
  computed: {
    previewImgStyle() {
      return {
        maxWidth: '100%',
        maxHeight: '100%',
        transform: `translate(${this.previewTx}px, ${this.previewTy}px) scale(${this.previewScale})`,
        transformOrigin: 'center center',
        cursor: this.previewDragging ? 'grabbing' : 'grab',
        userSelect: 'none',
        WebkitUserSelect: 'none',
      }
    },
  },
  watch: {
    visible(val) {
      if (val && this.equipmentId) {
        this.resetFiles()
        this.fetchDetail()
        this.closePreview()
      }
    },
    // 生产日期或使用期限变化，自动推算到期日期（与添加页一致）
    'form.production_date': 'calcExpiryDate',
    'form.service_life': 'calcExpiryDate',
  },
  methods: {
    emptyForm() {
      return {
        name: '',
        model: '',
        factory_no: '',
        department: '',
        manufacturer: '',
        production_date: '',
        install_date: '',
        warranty_expiry_date: '',
        service_life: '',
        price: '',
        status: 1,
        is_fixed_asset: '是',
        has_certificate: '无',
        has_registration: '无',
        has_production_license: '无',
        has_business_license: '无',
        expire_date: '',
        remark: '',
        // 已有文件 URL（只读展示用）
        photo_url: '',
        nameplate_url: '',
        qrcode_url: '',
        qualification_url: '',
      }
    },
    revokeBlob(url) {
      if (url && url.startsWith('blob:')) {
        window.URL.revokeObjectURL(url)
      }
    },
    resetFiles() {
      this.revokeBlob(this.photoPreviewUrl)
      this.revokeBlob(this.nameplatePreviewUrl)
      this.photoPreviewUrl = ''
      this.nameplatePreviewUrl = ''
      this.photoFile = null
      this.nameplateFile = null
      this.qualFile = null
      this.qualFileList = []
    },
    async fetchDetail() {
      this.loading = true
      try {
        const res = await equipmentApi.detail(this.equipmentId)
        const d = res.data
        this.form = {
          ...this.emptyForm(),
          name: d.name,
          model: d.model,
          factory_no: d.factory_no,
          department: d.department,
          manufacturer: d.manufacturer,
          production_date: d.production_date,
          install_date: d.install_date,
          warranty_expiry_date: d.warranty_expiry_date,
          service_life: d.service_life,
          price: d.price,
          status: d.status,
          is_fixed_asset: d.is_fixed_asset ? '是' : '否',
          has_certificate: d.has_certificate ? '有' : '无',
          has_registration: d.has_registration ? '有' : '无',
          has_production_license: d.has_production_license ? '有' : '无',
          has_business_license: d.has_business_license ? '有' : '无',
          expire_date: d.expire_date,
          remark: d.remark,
          photo_url: d.photo_url,
          nameplate_url: d.nameplate_url,
          qrcode_url: d.qrcode_url,
          qualification_url: d.qualification_url,
        }
      } catch (e) {
        this.$message.error('加载设备信息失败')
      } finally {
        this.loading = false
      }
    },
    // 自动生成到期日期：生产日期年份 + 使用期限（年），月日不变（与添加页一致）
    calcExpiryDate() {
      const pd = this.form.production_date
      const life = parseInt(this.form.service_life, 10)
      if (pd && !isNaN(life) && life > 0) {
        const parts = pd.split('-')
        if (parts.length === 3) {
          const y = parseInt(parts[0], 10)
          const m = parts[1]
          const d = parts[2]
          const ny = y + life
          this.form.warranty_expiry_date = `${ny}-${m}-${d}`
        }
      }
    },
    handlePhotoChange(file) {
      this.revokeBlob(this.photoPreviewUrl)
      this.photoFile = file.raw
      this.photoPreviewUrl = window.URL.createObjectURL(file.raw)
    },
    clearPhoto() {
      this.revokeBlob(this.photoPreviewUrl)
      this.photoPreviewUrl = ''
      this.photoFile = null
    },
    handlePhotoPreview() {
      this.openPreview(this.photoPreviewUrl || this.form.photo_url, '设备照片预览')
    },
    handleNameplateChange(file) {
      this.revokeBlob(this.nameplatePreviewUrl)
      this.nameplateFile = file.raw
      this.nameplatePreviewUrl = window.URL.createObjectURL(file.raw)
    },
    clearNameplate() {
      this.revokeBlob(this.nameplatePreviewUrl)
      this.nameplatePreviewUrl = ''
      this.nameplateFile = null
    },
    handleNameplatePreview() {
      this.openPreview(this.nameplatePreviewUrl || this.form.nameplate_url, '设备铭牌预览')
    },
    // 预览图：滚轮缩放 + 拖拽平移
    onPreviewWheel(e) {
      const factor = e.deltaY > 0 ? 0.9 : 1.1
      let next = this.previewScale * factor
      next = Math.min(4, Math.max(0.5, next))
      this.previewScale = next
    },
    onPreviewMouseDown(e) {
      this.previewDragging = true
      this._px = e.clientX
      this._py = e.clientY
    },
    onPreviewMouseMove(e) {
      if (!this.previewDragging) return
      this.previewTx += e.clientX - this._px
      this.previewTy += e.clientY - this._py
      this._px = e.clientX
      this._py = e.clientY
    },
    onPreviewMouseUp() {
      this.previewDragging = false
    },
    resetPreviewTransform() {
      this.previewScale = 1
      this.previewTx = 0
      this.previewTy = 0
      this.previewDragging = false
    },
    // ---- 自绘预览悬浮窗：打开 / 关闭 / 拖动 ----
    openPreview(url, title) {
      this.previewUrl = url
      this.previewTitle = title
      this.resetPreviewTransform()
      if (!this.panelW) {
        this.panelW = Math.min(920, Math.max(420, Math.round(window.innerWidth * 0.55)))
      }
      if (this.panelX === null || this.panelY === null) {
        // 默认放屏幕右侧，避开居中的表单；用户拖过就保留上次位置
        this.panelX = Math.max(20, window.innerWidth - this.panelW - 48)
        this.panelY = 90
      }
      this.panelX = Math.min(Math.max(this.panelX, 40 - this.panelW), window.innerWidth - 80)
      this.panelY = Math.min(Math.max(this.panelY, 0), window.innerHeight - 80)
      this.previewVisible = true
      document.addEventListener('keydown', this.onPreviewKeydown)
    },
    closePreview() {
      this.previewVisible = false
      this.resetPreviewTransform()
      document.removeEventListener('keydown', this.onPreviewKeydown)
    },
    onPreviewKeydown(e) {
      if (e.key === 'Escape') this.closePreview()
    },
    onPanelDragStart(e) {
      const offX = e.clientX - this.panelX
      const offY = e.clientY - this.panelY
      const move = (ev) => {
        this.panelX = Math.min(Math.max(ev.clientX - offX, 40 - this.panelW), window.innerWidth - 80)
        this.panelY = Math.min(Math.max(ev.clientY - offY, 0), window.innerHeight - 60)
      }
      const up = () => {
        document.removeEventListener('mousemove', move)
        document.removeEventListener('mouseup', up)
        window.removeEventListener('blur', up)
      }
      document.addEventListener('mousemove', move)
      document.addEventListener('mouseup', up)
      window.addEventListener('blur', up) // 拖出浏览器窗口松开鼠标时也能结束拖拽
    },
    handleQualFileChange(file, fileList) {
      this.qualFileList = fileList.slice(-1)
      this.qualFile = file.raw
    },
    handleQualFileRemove() {
      this.qualFileList = []
      this.qualFile = null
    },
    async handleSubmit() {
      const valid = await this.$refs.form.validate().catch(() => false)
      if (!valid) return

      this.submitting = true
      const formData = new FormData()

      const textFields = [
        'name', 'model', 'factory_no', 'department', 'manufacturer',
        'production_date', 'install_date', 'warranty_expiry_date',
        'service_life', 'price', 'expire_date', 'remark', 'status',
      ]
      textFields.forEach((key) => {
        const val = this.form[key]
        if (val !== undefined && val !== null && val !== '') {
          formData.append(key, val)
        }
      })

      formData.append('is_fixed_asset', this.form.is_fixed_asset === '是')
      formData.append('has_certificate', this.form.has_certificate === '有')
      formData.append('has_registration', this.form.has_registration === '有')
      formData.append('has_production_license', this.form.has_production_license === '有')
      formData.append('has_business_license', this.form.has_business_license === '有')

      // 仅当重新选择了文件时才上传，未选择则保留原文件
      if (this.photoFile) formData.append('photo_file', this.photoFile)
      if (this.nameplateFile) formData.append('nameplate_file', this.nameplateFile)
      if (this.qualFile) formData.append('qualification_pdf', this.qualFile)

      try {
        await equipmentApi.update(this.equipmentId, formData)
        this.$message.success('保存成功')
        this.$emit('success')
        this.$emit('update:visible', false)
      } catch (e) {
        const msg =
          e.response && e.response.data
            ? JSON.stringify(e.response.data)
            : '保存失败，请检查后端服务'
        this.$message.error(msg)
      } finally {
        this.submitting = false
      }
    },
    onClose() {
      this.resetFiles()
      this.form = this.emptyForm()
    },
  },
}
</script>

<style scoped>
.upload-row {
  text-align: center;
  margin-bottom: 12px;
}
.upload-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
  text-align: center;
}
.image-box {
  width: 160px;
  height: 160px;
  margin: 0 auto;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  background-color: #fafafa;
}
.image-box.has-image {
  border-style: solid;
  border-color: #409eff;
  background-color: #fff;
}
.preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.upload-placeholder {
  text-align: center;
  user-select: none;
}
.upload-icon {
  font-size: 28px;
  color: #8c939d;
  margin-bottom: 8px;
}
.upload-tip {
  font-size: 12px;
  color: #8c939d;
}
.qr-tip {
  font-size: 12px;
  color: #909399;
  text-align: center;
  margin-top: 8px;
}
/* 统一所有输入控件宽度，确保普通 input、date-picker、select 右侧边框对齐 */
.equipment-form /deep/ .el-input,
.equipment-form /deep/ .el-date-editor,
.equipment-form /deep/ .el-select {
  width: 100% !important;
  display: block;
}
/* 日期选择器内部 input 也强制撑满 */
.equipment-form /deep/ .el-date-editor .el-input__inner {
  width: 100% !important;
}
/* 隐藏 date-picker 默认日历后缀图标，避免右侧多出空间 */
.equipment-form /deep/ .el-input__suffix-inner .el-icon-date {
  display: none;
}
/* 带 append（如使用期限“年”）的输入框恢复默认内边距 */
.equipment-form /deep/ .el-input-group--append .el-input__inner {
  padding-right: 15px;
}
/* 自绘预览悬浮窗：可拖动、点击窗外穿透 */
.preview-float {
  position: fixed;
  z-index: 3000;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}
.preview-float-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  cursor: move;
  user-select: none;
}
.preview-float-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}
.preview-float-close {
  cursor: pointer;
  font-size: 18px;
  color: #909399;
}
.preview-float-close:hover {
  color: #409eff;
}
.preview-float-body {
  height: 65vh;
  overflow: hidden;
  background: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
}
.preview-float-tip {
  padding: 6px 0;
  text-align: center;
  font-size: 12px;
  color: #909399;
  border-top: 1px solid #ebeef5;
}
</style>
